import _ from 'lodash';
import Flickity from 'flickity';
require('flickity-fade');

class Gallery {
    createGallery(element) {
      this.flickity = new Flickity(
        element,
        Object.assign(this.options, this._options)
      );
    }
  
    constructor(element, options) {
      this._options = options;
      this.options = {
        wrapAround: true,
        autoPlay: true,
        fade: true,
        pageDots: element.querySelector("img").length > 1 ? true : false,
        prevNextButtons: element.querySelector("img").length > 1 ? true : false,
        cellSelector: ".slide",
        on: {
          ready: function () {
            document.querySelectorAll(".flickity-page-dots .dot").forEach(function (i, element) {
              element.prepend(`<span>${i + 1}</span>`);
            });
          },
          select: function (index) {
            const el = this.cells[index].element;
            const caption = element.parentElement.querySelector(".caption");
            if (caption) {
              caption.text(el.dataset.caption);
            }
          },
        },
      };
      this.createGallery(element);
    }
}

const galleries = document.querySelectorAll(".gallery");
if (galleries) {
  galleries.forEach(function (element) {
    new Gallery(element);
  });
}
